// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AngleMeasurement[data-v-8107c9d0]{width:35px;height:35px}.AngleMeasurement>img[data-v-8107c9d0]{width:100%;height:100%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
